import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa"; // Removed unused FaFilePdf import
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { fetchCustomerInvoice } from "../../store/Slices/CustomerInvoiceSlice";
import InvoicePDF from "./InvoicePDF"; // Ensure InvoicePDF is correctly exported
import { useReactToPrint } from "react-to-print";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { CompanyCompleteLedgerColumns } from "../../assets/Columns/CompanyCompleteLedgerColumns";
import { fetchProducts } from "../../store/Slices/ProductSlice";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchCustomerLedger } from "../../store/Slices/CustomerLedgerSlice";
import { fetchSupplierLedger } from "../../store/Slices/SupplierLedgerSlice";
import { formatDateTime } from "../../utils/dateTime";

const CompanyLegderReport = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const SupplierLedgers = useSelector((state) => state.SupplierLedgers);

  const Suppliers = useSelector((state) => state.Suppliers);

  useEffect(() => {
    dispatch(fetchSuppliers());
  }, [dispatch]);

  const supplierLedgerSummary = useMemo(() => {
    if (!SupplierLedgers.data.length) return { cr: 0, dr: 0, qty: 0 };

    return SupplierLedgers.data.reduce(
      (acc, item) => ({
        cr: acc.cr + (item.cr || 0),
        dr: acc.dr + (item.dr || 0),
        qty: acc.qty + (item.qty || 0),
      }),
      { cr: 0, dr: 0, qty: 0 }
    );
  }, [SupplierLedgers.data]);

  useEffect(() => {
    dispatch(fetchSupplierLedger(id));
    console.log(SupplierLedgers.data.all);
  }, [id]);

  const contentToPrint = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: "Print This Document",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  });

  const AmountTitleConverter = (amoutTitle) => {
    console.log(amoutTitle);

    switch (amoutTitle) {
      case "Payable":
        return "Remaining";
      case "Paid":
        return "Paid";
      case "Total":
        return "Total";
      default:
        return amoutTitle;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-[12vh] flex items-center justify-center gap-x-3 relative w-full mb-10">
        <div
          className="border-2 border-ink px-2 py-2 rounded-full hover:text-white hover:bg-ink transition-colors ease-in-out duration-200 cursor-pointer absolute top-0 left-5"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </div>
        <button
          className="px-2 py-2 border-2 border-ink hover:rounded-lg transition-colors ease-in-out duration-200 hover:bg-ink/80 bg-ink text-white hover:text-white cursor-pointer w-[200px] flex justify-center items-center font-bold my-3"
          onClick={() => {
            handlePrint(null, () => contentToPrint.current, null);
          }}
        >
          PRINT
        </button>
      </div>

      <div ref={contentToPrint} className="flex flex-col w-auto p-1">
        <img
          src={`/banner.jpeg`}
          alt="banner"
          className="w-[100%] h-auto border-2 border-[#002650] rounded-t-lg"
        />
        {/* customer details */}
        <div className="flex w-full bg-main text-white justify-center items-center py-2 font-bold text-xl px-3 mt-1 font-quicksand">
          Company Ledger Report
        </div>

        {/* Invoice Items Table */}
        {SupplierLedgers?.data?.all.length > 0 && (
          <div className="w-full overflow-x-auto mt-1">
            <table className="w-full text-left border-collapse border border-main">
              <thead className="bg-main text-white">
                <tr>
                  {CompanyCompleteLedgerColumns.filter(
                    (dt) => dt.id !== "actions" && dt.id !== "description"
                  ).map((dt, ci) => {
                    return (
                      <th
                        className={`border border-main px-3 py-2 whitespace-nowrap ${
                          ci === 0
                            ? "w-[120px]"
                            : ci === 1
                            ? "w-[100px]"
                            : ci === 2
                            ? "w-fit"
                            : ci === 3
                            ? "w-fit"
                            : ci === 4
                            ? "w-[80px]"
                            : ci === 5
                            ? "w-[120px]"
                            : ci === 6
                            ? "w-[120px]"
                            : "w-[120px]"
                        }`}
                      >
                        {["payable", "paid", "total"].includes(dt.id)
                          ? AmountTitleConverter(dt.title)
                          : dt.id === "price"
                          ? "Price"
                          : dt.title}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {SupplierLedgers.data.all.map((item, index) => (
                  <tr key={index} className="text-main">
                    {CompanyCompleteLedgerColumns.filter(
                      (dt) => dt.id !== "actions" && dt.id !== "description"
                    ).map((dt) => {
                      return (
                        <td
                          className={`border border-main px-3 py-2 ${
                            ["payable", "paid", "total"].includes(dt.id) &&
                            "font-bold"
                          }`}
                        >
                          {[
                            "payable",
                            "cr",
                            "dr",
                            "price",
                            "paid",
                            "total",
                          ].includes(dt.id)
                            ? `Rs ${Number(item[dt.id]).toLocaleString(
                                "en-PK"
                              )}`
                            : dt.id === "companyId"
                            ? item.companyId.name
                            : dt.id === "date"
                            ? formatDateTime(item[dt.id])
                            : item[dt.id]}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="mt-6 grid grid-cols-3 gap-4">
          <div className="bg-card p-4 rounded-lg shadow-card">
            <h3 className="text-muted text-sm font-medium">Total Amount</h3>
            <p className="text-2xl font-bold text-ink">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.total.toLocaleString()}
            </p>
          </div>
          <div className="bg-card p-4 rounded-lg shadow-card">
            <h3 className="text-muted text-sm font-medium">Total Paid</h3>
            <p className="text-2xl font-bold text-success">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.paid.toLocaleString()}
            </p>
          </div>
          <div className="bg-card p-4 rounded-lg shadow-card">
            <h3 className="text-muted text-sm font-medium">Total Payable</h3>
            <p className="text-2xl font-bold text-danger">
              Rs{" "}
              {Suppliers.data
                .find((dt) => {
                  return dt._id === id;
                })
                ?.payable.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyLegderReport;
